import styled, { css } from 'styled-components';

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const ReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Action = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  h1{
    margin: 0;
    margin-bottom: 8px
  }
`;

export const InitialAction = styled.div`
  border-bottom: 1px #bdbdbd solid;
  margin-bottom: 8px;
  padding-bottom: 6px;
`;

export const ActionField = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  max-width: 295px;
  column-gap: 16px;

  span {
    overflow-wrap: break-word;
    font-weight: bold;
    width: 100%;
    overflow-wrap: break-word;

    & + span{
      font-weight: normal;
    }
  }
`;

export const ActionsFields = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 6px;
`;

export const InitialRegisterTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
`;